<template>
    <div class="box">
        <p class="mb-1 has-text-weight-bold">
            {{ translate("admin_verification.verification_settings") }}
        </p>

        <div v-if="loading">
            <InlineSpinner />
        </div>
        <template v-else>
            <div>
                <span class="icon">
                    <i v-if="store.earlyVerificationBlocked" class="fas fa-check-circle has-text-success" />
                    <i v-else class="fas fa-times-circle has-text-danger" />
                </span>
                <span v-if="store.earlyVerificationBlocked">
                    {{ translate("admin_verification.block_early_verification_btn") }}:
                    {{ translate("admin_verification.block_early_verification_btn_on") }} (+/- {{ store.humanEarlyVerificationPeriod }})
                </span>
                <span v-else>
                    {{ translate("admin_verification.block_early_verification_btn") }}:
                    {{ translate("admin_verification.block_early_verification_btn_off") }}
                </span>
            </div>

            <div>
                <span class="icon">
                    <i v-if="store.queueVerificationBlocked" class="fas fa-check-circle has-text-success" />
                    <i v-else class="fas fa-times-circle has-text-danger" />
                </span>
                <span v-if="store.queueVerificationBlocked">
                    {{ translate("admin_verification.block_queue_verification") }}:
                    {{ translate("admin_verification.block_early_verification_btn_on") }} ({{
                        translate("admin_verification.queue_lock_limit", false, [store.effectiveQueueVerificationLimit])
                    }})
                </span>
                <span v-else>
                    {{ translate("admin_verification.block_queue_verification") }}:
                    {{ translate("admin_verification.block_early_verification_btn_off") }}
                </span>
            </div>

            <div>
                <span class="icon">
                    <i v-if="store.autoDqWhenCategoryBeginsEnabled" class="fas fa-check-circle has-text-success" />
                    <i v-else class="fas fa-times-circle has-text-danger" />
                </span>
                <span>{{ translate("admin_verification.auto_dq_unverified_when_category_begins") }}</span>
            </div>
        </template>

        <button v-if="canChangeSettings" class="button is-small mt-3" @click="emit('change')">
            <span class="icon">
                <i class="fas fa-wrench" />
            </span>
            <span>{{ translate("page.category_manager.change_settings") }}</span>
        </button>
    </div>
</template>

<script setup lang="ts">
    import InlineSpinner from "../Common/InlineSpinner.vue";
    import { translate } from "../Common/translations";
    import { useVerificationStore } from "./verificationStore";

    defineProps<{
        loading: boolean;
        canChangeSettings: boolean;
    }>();

    const emit = defineEmits<{
        change: [];
    }>();

    const store = useVerificationStore();
</script>
